import { useEffect, useReducer } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import reducer, {
  initState,
  reloadStateAction,
  setDataSourceAction,
} from './reducer'
import { useLocation } from 'react-router-dom'
import { userRouter } from '../../route'
import { DELETE_PRODUCT_CACHE } from '../../api/MaterialApi'
import { useCloseTab } from '../../tools/utilHooks'

const UsePaymentDetailsHook = () => {
  const dispatchRedux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const [state, dispatch] = useReducer(reducer, initState)
  const location = useLocation()
  const supRoute = userRouter[1].url
  const { onCurrentPageClose } = useCloseTab()

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
      },
    })
    dispatchRedux(action)
  }

  // 获取缓存数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  useEffect(() => {
    const flag = getpagecache()
    if ((location.state as any)?.data) {
      DELETE_PRODUCT_CACHE()
      dispatch(setDataSourceAction((location.state as any).data))
    } else if (flag?.pageState) {
      dispatch(reloadStateAction(flag.pageState))
    }
  }, [])

  useEffect(() => {
    // 缓存存数据
    onCache()
    // eslint-disable-next-line
  }, [state])

  const clickResult = () => {
    onCurrentPageClose()
    history.replace({
      pathname: `${supRoute}/mylaunch`,
      state: {
        type: 'GOODS',
      },
    })
  }

  const clickNext = () => {
    onCurrentPageClose()
    history.replace({
      pathname: `${supRoute}/addgoods`,
      state: {
        type: 'GOODS',
        auditSource: 'SRM_SECOND_ADD', // 审核来源：SCP新增物料
      },
    })
  }
  return {
    state,
    clickResult,
    clickNext,
  }
}

export default UsePaymentDetailsHook
import { useEffect, useReducer } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import reducer, {
  initState,
  reloadStateAction,
  setDataSourceAction,
} from './reducer'
import { useLocation } from 'react-router-dom'
import { userRouter } from '../../route'
import { DELETE_PRODUCT_CACHE } from '../../api/MaterialApi'
import { useCloseTab } from '../../tools/utilHooks'

const UsePaymentDetailsHook = () => {
  const dispatchRedux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const [state, dispatch] = useReducer(reducer, initState)
  const location = useLocation()
  const supRoute = userRouter[1].url
  const { onCurrentPageClose } = useCloseTab()

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
      },
    })
    dispatchRedux(action)
  }

  // 获取缓存数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  useEffect(() => {
    const flag = getpagecache()
    if ((location.state as any)?.data) {
      DELETE_PRODUCT_CACHE()
      dispatch(setDataSourceAction((location.state as any).data))
    } else if (flag?.pageState) {
      dispatch(reloadStateAction(flag.pageState))
    }
  }, [])

  useEffect(() => {
    // 缓存存数据
    onCache()
    // eslint-disable-next-line
  }, [state])

  const clickResult = () => {
    onCurrentPageClose()
    history.replace({
      pathname: `${supRoute}/mylaunch`,
      state: {
        type: 'GOODS',
      },
    })
  }

  const clickNext = () => {
    onCurrentPageClose()
    history.replace({
      pathname: `${supRoute}/addgoods`,
      state: {
        type: 'GOODS',
        auditSource: 'SRM_SECOND_ADD', // 审核来源：SCP新增物料
      },
    })
  }
  return {
    state,
    clickResult,
    clickNext,
  }
}

export default UsePaymentDetailsHook
